module.exports = __webpack_public_path__ + "img/qt-wjfxgl.e6631e48.svg";